import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import {
  IntegrationsListActions,
  IntegrationsListModuleActions,
  IntegrationsListModuleState
} from '~/store/integrations/list'

interface IntegrationsListStoreComputed {
  integrations: () => IntegrationsListModuleState['integrations']
}

interface IntegrationsListStoreActions {
  fetchIntegrations: (
    args: Parameters<IntegrationsListModuleActions[IntegrationsListActions.FETCH_INTEGRATIONS]>[1]
  ) => Promise<void>
}

export default defineComponent({
  name: 'IntegrationsListMixin',

  computed: {
    ...(mapState('integrations/list', {
      integrations: (state: any) => state.integrations
    }) as IntegrationsListStoreComputed)
  },

  methods: {
    ...(mapActions('integrations/list', {
      fetchIntegrations: IntegrationsListActions.FETCH_INTEGRATIONS
    }) as IntegrationsListStoreActions)
  }
})
